<template>
  <div class="container">
    <el-container>
      <el-header>
        <el-row type="flex" :gutter="10" style="width: 100vw">
          <el-col :span="3">
            <el-select
              filterable
              v-model="filterOption.appId"
              placeholder="客户端类型"
              clearable
              size="mini"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in appList"
                :key="index"
              />
            </el-select>
          </el-col>

          <el-col :span="4" :offset="17">
            <div style="float: right">
              <el-button type="primary" size="mini" @click="doSearch">{{
                $t("system.search")
              }}</el-button>
              <el-button type="warning" size="mini" @click="doReset">{{
                $t("system.reset")
              }}</el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <div class="tableHeader">
          <!-- <el-button size="mini">{{ $t("system.import") }}</el-button> -->
          <el-button size="mini" @click="showCreateDialog">{{
            $t("system.create")
          }}</el-button>
          <!-- <el-button size="mini">{{ $t("system.delete") }}</el-button> -->
        </div>
        <el-table
          :data="tableData"
          ref="versionTable"
          border
          :height="tHeight"
          v-loading="isTableLoading"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            :label="$t('system.index')"
            width="60"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            prop="appId"
            label="应用ID"
            align="center"
            width="120"
            show-overflow-tooltip
          >
            <template #default="scope">
              {{ getAppName(scope.row.appId) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="versionName"
            label="版本序号"
            align="center"
            width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="versionCode"
            label="版本号"
            align="center"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="targetName"
            label="文件名称"
            align="center"
            width="220"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="isReleaseStr"
            label="是否Release"
            align="center"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="releaseNote"
            label="版本说明"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="创建人"
            align="center"
            width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            width="160"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="upgradeDate"
            label="版本升级时间"
            align="center"
            width="160"
            show-overflow-tooltip
          ></el-table-column>
                    <el-table-column
            :label="$t('system.operation')"
            fixed="right"
            align="center"
            width="150"
          >
            <template v-slot="scope">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-download"
                @click="download(scope.row)"
              >{{ $t("system.download") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right; margin-top: 10px">
          <el-pagination
            @size-change="onTableSizeChange"
            @current-change="onTablePageChange"
            :current-page="filterOption.pageNo"
            :page-sizes="[10, 50, 100, 200]"
            layout="total,sizes,prev, pager, next"
            :total="filterOption.total"
          ></el-pagination>
        </div>
      </el-main>
    </el-container>

    <create-rate-dialog
      v-if="isShowCreateDialog"
      :isShowDialog="isShowCreateDialog"
      @onDialogClose="closeCreateDialog"
    />
  </div>
</template>

<script>
import baseServer from "./source/basedata";
import mixin from "@/utils/mixin.js";
import CreateRateDialog from "./dialogs/createRate";

export default {
  name: "pda",
  components: {
    CreateRateDialog,
  },
  mixins: [mixin],
  data() {
    return {
      isTableLoading: false,
      isShowCreateDialog: false,
      isShowUpdateDialog: false,
      filterOption: {
        appId: null,
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      appList: [
        {
          id: 1,
          name: "CBS",
        },
        {
          id: 3,
          name: "PDA",
        },
        {
          id: 5,
          name: "New PDA",
        },
                {
          id: 6,
          name: "ICS PDA",
        },
      ],
      // organizationList: [
      //   { id: 1, name: "壹站供应链管理有限公司" },
      //   { id: 2, name: "上海道骊物流有限公司" }
      // ],
      tableData: [],
      tableSelection: [],
      currentRow: null,
    };
  },
  computed: {
    tHeight() {
      return this.tableHeight - 135;
    },
  },
  mounted() {},
  methods: {
    async download(row) {
      let res = await baseServer.previewFile(row.targetName);
      if(res && res.code == 200){
        window.open(res.data,'_blank')
      }
    },
    getAppName(appId) {
      let appInfo = this.appList.find((item) => appId == "" + item.id);
      return appInfo ? appInfo.name : "-";
    },
    doSearch() {
      baseServer
        .queryVersionList({
          ...this.filterOption,
          current: this.filterOption.pageNo,
          size: this.filterOption.pageSize,
        })
        .then((res) => {
          this.tableData = res.data ? res.data.records : [];
          this.filterOption.total = res.data.total;
        });
    },
    edit(row) {
      this.currentRow = row;
      this.isShowUpdateDialog = true;
    },
    del(row) {
      console.log(row);
    },
    onTableSelectionChange(val) {
      this.tableSelection = val;
    },
    onTableSizeChange(size) {
      this.filterOption = { ...this.filterOption, pageSize: size, pageNo: 1 };
      this.doSearch();
    },
    onTablePageChange(page) {
      this.filterOption = { ...this.filterOption, pageNo: page };
      this.doSearch();
    },
    showCreateDialog() {
      this.isShowCreateDialog = true;
    },
    closeCreateDialog() {
      this.isShowCreateDialog = false;
    },
    closeUpdateDialog() {
      this.isShowUpdateDialog = false;
    },
    doReset() {
      this.filterOption = {
        appid: null,
        targetCurrency: null,
        orgId: null,

        pageNo: 1,
        pageSize: 10,
        total: 0,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  height: calc(100% - 20px);
  background-color: white;
  overflow-y: scroll;
  padding: 10px;

  .el-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 10px;
    :deep(el-form-item) {
      margin-right: 10px;
    }
  }

  :deep(.el-main) {
    padding: 0 20px;
    .tableHeader {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 48px;
    }
  }
}
</style>
